import React from "react";
import { useParams, Navigate } from "react-router-dom";
import { useSiteData } from "../context/SiteData";

// Handles old, pre-redesign links like /location/OQ== (still indexed by
// Google) — that scheme base64-encoded a 1-based position in the outlets
// list rather than today's slug (e.g. "karnal"). Decode it, map it to the
// outlet currently at that position, and send the visitor to the real page
// instead of a blank screen.
export default function LegacyLocationRedirect() {
  const { encoded } = useParams();
  const { data, loading, loaded } = useSiteData();

  if (loading) return null;

  let outlet = null;
  if (loaded) {
    try {
      const decoded = atob(encoded);
      const position = parseInt(decoded, 10);
      if (Number.isInteger(position) && position >= 1) {
        outlet = data.outlets[position - 1] || null;
      }
    } catch (e) {
      // not valid base64 — fall through to the /locations redirect below
    }
  }

  return <Navigate to={outlet ? `/locations/${outlet.id}` : "/locations"} replace />;
}
